import { Deferred } from '@inertiajs/react'
import { TopTopicsCard } from '@/components/analytics/TopTopicsCard'
import { PanelSkeleton } from '@/components/analytics/PanelSkeleton'
import { usePanel } from '@/components/analytics/usePanel'
import type { TopTopicsPanel } from '@/types/analytics'

export function TopicsSection() {
  return (
    <Deferred data="top_topics" fallback={<PanelSkeleton className="h-56" />}>
      <TopTopicsDeferred />
    </Deferred>
  )
}

function TopTopicsDeferred() {
  const data = usePanel<TopTopicsPanel>('top_topics')
  return data ? <TopTopicsCard data={data} /> : null
}
